export function LockedArtFrame({ code, title, note, className = "" }) {
  return (
    <div className={`locked-frame ${className}`} data-testid={`${code.toLowerCase().replaceAll(" ", "-")}-locked-frame`}>
      <div className="frame-corner frame-corner-tl" />
      <div className="frame-corner frame-corner-tr" />
      <div className="frame-corner frame-corner-bl" />
      <div className="frame-corner frame-corner-br" />
      <div className="frame-grid" />
      <div className="frame-crosshair" />
      <div className="locked-frame-content">
        <span>{code}</span>
        <strong>{title}</strong>
        <small>{note}</small>
      </div>
    </div>
  );
}
